import { useState, useEffect } from "react";
import Select from "react-select";
import "./Analytics.css";
import { getMonthlyTransactionById } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import DateFilter from "../../../components/common/DateFilter";

const AnalyticsHeader = ({
  userList,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setTableData,
  tableData,
  isLoading,
  setIsLoading,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [totalOptions, setTotalOptions] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [selectName, setSelectName] = useState(null);

  const handleChange = async (selected) => {
    // CLEAR action
    if (!selected) {
      setSelectedOption(null);
      setSelectedId(null);
      setSelectName(null);
      setTableData([]);
      setIsLoading(false);
      return;
    }
    setSelectedOption(selected);
    setSelectedId(selected.value);
    setSelectName(selected.label);

    // if (!selected.value) return;

    setIsLoading(true);
    try {
      const analytics = await getMonthlyTransactionById(
        selected.value,
        startDate,
        endDate,
      );
      setTableData(analytics.dateRanges);
    } catch (error) {
      console.error("Error fetching merchant data:", error);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const myData = [];

    userList?.map((item) => {
      myData.push({ value: item.id, label: item?.alias || item?.id });
    });

    setTotalOptions(myData);
  }, [userList]);

  useEffect(() => {
    if (userList?.length > 0) {
      // const firstUser = userList[0];
      // setSelectedOption({ value: firstUser.id, label: firstUser.alias || firstUser.id });
      // setSelectedId(firstUser.id);
      // setSelectName(firstUser.name);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const startISO = today.toISOString();

      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 999);
      const endISO = endOfDay.toISOString();

      setStartDate(startISO);
      setEndDate(endISO);

      // const fetchCurrentDetails = async () => {
      //   setIsLoading(true);
      //   const analytics = await getMonthlyTransactionById(firstUser.id, startISO, endISO);
      //   setTableData(analytics.dateRanges);
      //   setIsLoading(false);
      // };

      // fetchCurrentDetails();
    }
  }, [userList]);

  const handleDateChange = async (start, end) => {
    setStartDate(start);
    setEndDate(end);

    if (!selectedId) return;

    setIsLoading(true);
    try {
      const analytics = await getMonthlyTransactionById(selectedId, start, end);

      setTableData(analytics.dateRanges);
    } catch (err) {
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="analytics-header">
        <h2>Merchant Ledger</h2>

        <div className="analytics-sub-head">
          {/* <button className="analytics-export-btn"  >Export</button> */}
          {/* <ReportExcel tableData={tableData} fileName={selectName} /> */}
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Select
              value={selectedOption}
              options={totalOptions}
              onChange={handleChange}
              placeholder="Select Merchant..."
              isClearable
            />
          </div>
        </div>
      </div>
      <DateFilter onDateChange={handleDateChange} />
    </>
  );
};

export default AnalyticsHeader;
